import {
  CodeModuleArtifact,
  type PublicCodeModuleArtifact,
} from '@packages/systems/code-modules/core';
import {Environment} from './types';

/**
 * Legacy wire map from build env → component artifact.
 *
 * Kept for the pre-artifact init/sign wire that still keys urls / files by
 * `Environment`. Layout and upload no longer go through this map — those use
 * `CODE_MODULE_ARTIFACTS[artifact].outDir` / `BundleFile.artifact`. Keyed by
 * `Environment`, so it is total over build environments and not over
 * artifacts: an artifact built outside the component pipeline has no env row
 * here, and adding one never requires editing this map.
 *
 * Lives here (not beside `CODE_MODULE_ARTIFACTS` in code-modules) so
 * code-modules does not depend on build `Environment`.
 *
 * Typed over `PublicCodeModuleArtifact`: every build environment produces a
 * component artifact that gets a public CDN url. A private artifact here would
 * already be a modeling mistake.
 */
export const COMPONENT_ARTIFACT_BY_ENVIRONMENT: Record<
  Environment,
  PublicCodeModuleArtifact
> = {
  [Environment.Client]: CodeModuleArtifact.ComponentsBundle,
  [Environment.Server]: CodeModuleArtifact.ComponentsSSRBundle,
};
